import {environment} from "../../environments/environment";

const langTutorial = { note: "<ul><li>1. </li><li>2. </li></ul>" };
langTutorial[environment.DEFAULT_LANGUAGE] = "<p>...</p>";

interface Tutorials {
  [key: string]: {[key: string]: string};
}

export class TutorialBase {
  constructor() {
    this.tutorials = {
      general: langTutorial,
    };
  }
  public tutorials: Tutorials;

  public static addProperty(name: string): Tutorials {
    const property = {};
    property[name] = langTutorial;
    return property;
  }
}
